import ChildrenList from './ChildrenList.vue';

export * from './types';
export default ChildrenList;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/index.ts